export enum GroupName {
  Style = 'Style',
  Type = 'Type',
}
